import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const ServiceTypeAddModal = ({ serviceType, onSave, onCancel }) => {
  const [name, setName] = useState(serviceType?.name || "");
  const [submitLabel, setSubmitLabel] = useState(serviceType ? "UPDATE" : "ADD");

  useEffect(() => {
    setName(serviceType?.serviceType || "");
    setSubmitLabel(serviceType ? "UPDATE" : "ADD");
  }, [serviceType]);

  const handleSave = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      toast("Service name is required");
      return;
    }
    onSave(trimmed);
  };

  return (
    <div
      onClick={onCancel}
      className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-30"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[348px] h-[200px] bg-white rounded-[6px] p-[18px] flex flex-col"
      >
        <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor mb-5">
          {serviceType ? "UPDATE SERVICE" : "ADD SERVICE"}
        </p>

        <div className="flex flex-col justify-between h-full">
          <div className="h-[60px] w-full">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">Name</p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
              <input
                value={name}
                type="text"
                onChange={(e) => setName(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Enter service name"
              />
            </div>
          </div>

          <div className=" w-full">
            <div className="flex items-center justify-between gap-4">
              <div
                onClick={onCancel}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
              >
                CANCEL
              </div>
              <div
                onClick={handleSave}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-blueColor text-white cursor-pointer"
              >
                {submitLabel}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceTypeAddModal;